function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import { Button, DropdownMenu } from '@deephaven/components';
import { vsGear, dhTrashUndo } from '@deephaven/icons';
import { assertNotNull } from '@deephaven/utils';
import * as monaco from 'monaco-editor';
import ConsoleUtils from "../common/ConsoleUtils.js";
import LogLevel from "./LogLevel.js";
import "./LogView.css";
import LogLevelMenuItem from "./LogLevelMenuItem.js";
import { MonacoUtils } from "../monaco/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Log view contents. Uses a monaco editor to display/search the contents of the log.
 */
class LogView extends PureComponent {
  static getLogText(logItem) {
    var date = new Date(logItem.micros / 1000);
    var timestamp = ConsoleUtils.formatTimestamp(date);
    return "".concat(timestamp, " ").concat(logItem.logLevel, " ").concat(logItem.message);
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "cancelListener", void 0);
    _defineProperty(this, "editor", void 0);
    _defineProperty(this, "editorContainer", void 0);
    _defineProperty(this, "logLevelMenuItems", void 0);
    _defineProperty(this, "flushTimer", void 0);
    _defineProperty(this, "bufferedMessages", void 0);
    _defineProperty(this, "messages", void 0);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.handleFlushTimeout = this.handleFlushTimeout.bind(this);
    this.handleLogMessage = this.handleLogMessage.bind(this);
    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleToggleAllClick = this.handleToggleAllClick.bind(this);
    this.logLevelMenuItems = {};
    this.editorContainer = null;
    this.bufferedMessages = [];
    this.messages = [];
    this.state = {
      shownLogLevels: {}
    };
  }
  componentDidMount() {
    this.resetLogLevels();
    this.initMonaco();
    this.startListening();
    window.addEventListener('resize', this.handleResize);
  }
  componentDidUpdate(prevProps, prevState) {
    this.updateDimensions();
    var shownLogLevels = this.state.shownLogLevels;
    if (prevState.shownLogLevels !== shownLogLevels) {
      this.refreshLogText();
    }
    var session = this.props.session;
    if (prevProps.session !== session) {
      this.stopListening();
      this.startListening();
      // clear logs when starting a new console
      this.clearLogs();
    }
  }
  componentWillUnmount() {
    this.stopFlushTimer();
    this.stopListening();
    this.destroyMonaco();
    window.removeEventListener('resize', this.handleResize);
  }
  getMenuActions(shownLogLevels) {
    var _this = this;
    var actions = [];
    actions.push({
      menuElement: /*#__PURE__*/_jsx("div", {
        className: "log-level-menu-title",
        children: "Display Log Levels"
      }),
      group: 1,
      order: 10
    });
    var _loop = function _loop() {
      var logLevel = LogView.AllLogLevels[i];
      var on = shownLogLevels[logLevel] != null ? shownLogLevels[logLevel] : false;
      actions.push({
        title: logLevel,
        group: 1,
        order: i + 100,
        menuElement: /*#__PURE__*/_jsx(LogLevelMenuItem, {
          logLevel: logLevel,
          on: on,
          onClick: _this.handleMenuItemClick,
          ref: element => {
            if (element != null) {
              _this.logLevelMenuItems[logLevel] = element;
            }
          }
        })
      });
    };
    for (var i = 0; i < LogView.AllLogLevels.length; i += 1) {
      _loop();
    }
    actions.push({
      group: 1,
      order: 1000,
      menuElement: /*#__PURE__*/_jsxs("div", {
        className: "log-level-menu-controls",
        children: [/*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: "log-level-toggle-all",
          onClick: this.handleToggleAllClick,
          children: "Toggle All"
        }), /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          onClick: this.handleResetClick,
          children: "Reset"
        })]
      })
    });
    return actions;
  }
  resetLogLevels() {
    var shownLogLevels = {};
    var _loop2 = function _loop2() {
      var logLevel = LogView.AllLogLevels[i];
      var isEnabled = LogView.DefaultLogLevels.some(level => level === logLevel);
      shownLogLevels[logLevel] = isEnabled;
    };
    for (var i = 0; i < LogView.AllLogLevels.length; i += 1) {
      _loop2();
    }
    this.setState({
      shownLogLevels
    });
  }
  startListening() {
    var session = this.props.session;
    this.cancelListener = session.onLogMessage(this.handleLogMessage);
  }
  stopListening() {
    if (this.cancelListener != null) {
      this.cancelListener();
      this.cancelListener = undefined;
    }
  }
  initMonaco() {
    assertNotNull(this.editorContainer);
    this.editor = monaco.editor.create(this.editorContainer, {
      copyWithSyntaxHighlighting: false,
      fixedOverflowWidgets: true,
      folding: false,
      fontFamily: 'Fira Mono',
      glyphMargin: false,
      language: 'log',
      lineDecorationsWidth: 0,
      lineNumbers: 'off',
      lineNumbersMinChars: 0,
      minimap: {
        enabled: false
      },
      readOnly: true,
      renderLineHighlight: 'none',
      scrollBeyondLastLine: false,
      value: '',
      wordWrap: 'on'
    });

    // Override default Monaco keybindings for `escape` and `shift-escape`
    [[monaco.KeyCode.Escape], [monaco.KeyMod.Shift | monaco.KeyCode.Escape] // eslint-disable-line no-bitwise
    ].forEach(keybindings => {
      assertNotNull(this.editor);

      // Monaco default behavior is for escape key to close the find widget.
      // Instead, capture it and do nothing. Same for shift-escape.
      MonacoUtils.disableKeyBindings(this.editor, keybindings);

      // Restore regular escape to clear selection, when editorText has focus.
      this.editor.addAction({
        id: 'clear-selection-on-escape',
        label: '',
        keybindings: [monaco.KeyCode.Escape],
        keybindingContext: 'findWidgetVisible && editorTextFocus',
        run: () => {
          var _this$editor, _this$editor2;
          var position = (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.getPosition();
          assertNotNull(position);
          (_this$editor2 = this.editor) === null || _this$editor2 === void 0 || _this$editor2.setPosition(position);
        }
      });
    });
  }
  destroyMonaco() {
    if (this.editor) {
      this.editor.dispose();
      this.editor = undefined;
    }
  }
  triggerFindWidget() {
    var _this$editor3, _this$editor4;
    // The actions.find action can no longer be triggered when the editor is not in focus, with monaco 0.22.x.
    // As a workaround, just focus the editor before triggering the action
    // https://github.com/microsoft/monaco-editor/issues/2355
    (_this$editor3 = this.editor) === null || _this$editor3 === void 0 || _this$editor3.focus();
    (_this$editor4 = this.editor) === null || _this$editor4 === void 0 || _this$editor4.trigger('keyboard', 'actions.find', undefined);
  }
  toggleAll() {
    var shownLogLevels = this.state.shownLogLevels;
    var isAllEnabled = true;
    for (var i = 0; i < LogView.AllLogLevels.length; i += 1) {
      var logLevel = LogView.AllLogLevels[i];
      if (!shownLogLevels[logLevel]) {
        isAllEnabled = false;
        break;
      }
    }
    if (isAllEnabled) {
      this.setState({
        shownLogLevels: {}
      });
    } else {
      var updatedLogLevels = {};
      for (var _i = 0; _i < LogView.AllLogLevels.length; _i += 1) {
        var _logLevel = LogView.AllLogLevels[_i];
        updatedLogLevels[_logLevel] = true;
      }
      this.setState({
        shownLogLevels: updatedLogLevels
      });
    }
  }
  toggleLogLevel(logLevel) {
    var shownLogLevels = this.state.shownLogLevels;
    var isEnabled = shownLogLevels[logLevel];
    var updatedLogLevels = {};
    updatedLogLevels[logLevel] = !isEnabled;
    this.updateLogLevels(updatedLogLevels);
  }
  updateLogLevels(updatedLogLevels) {
    var shownLogLevels = this.state.shownLogLevels;
    shownLogLevels = _objectSpread(_objectSpread({}, shownLogLevels), updatedLogLevels);
    this.setState({
      shownLogLevels
    });
  }
  appendLogText(text) {
    if (!this.editor) {
      return;
    }
    var model = this.editor.getModel();
    var line = model === null || model === void 0 ? void 0 : model.getLineCount();
    assertNotNull(line);
    var column = model === null || model === void 0 ? void 0 : model.getLineLength(line);
    assertNotNull(column);
    var isBottomVisible = this.isBottomVisible();
    var edits = [];
    if (column > 0) {
      edits.push({
        range: {
          startLineNumber: line,
          startColumn: column + 1,
          endLineNumber: line,
          endColumn: column + 1
        },
        text: '\n',
        forceMoveMarkers: true
      });
      line += 1;
      column = 0;
    }
    edits.push({
      range: {
        startLineNumber: line,
        startColumn: column,
        endLineNumber: line,
        endColumn: column
      },
      text,
      forceMoveMarkers: true
    });
    model === null || model === void 0 || model.applyEdits(edits);
    if (isBottomVisible) {
      var lineCount = model === null || model === void 0 ? void 0 : model.getLineCount();
      assertNotNull(lineCount);
      this.editor.revealLine(lineCount, 1);
    }
  }

  /**
   * Refresh the contents of the log component with the updated filter text
   */
  refreshLogText() {
    if (!this.editor) {
      return;
    }
    this.truncateLogIfNecessary();
    var shownLogLevels = this.state.shownLogLevels;
    var isBottomVisible = this.isBottomVisible();
    var text = '';
    for (var i = 0; i < this.messages.length; i += 1) {
      var message = this.messages[i];
      if (shownLogLevels[message.logLevel]) {
        var logText = LogView.getLogText(message);
        if (logText.length > 0) {
          text += logText;
          if (logText.charAt(logText.length - 1) !== '\n') {
            text += '\n';
          }
        }
      }
    }
    text = text.trimRight();
    this.editor.setValue(text);
    if (isBottomVisible) {
      var _this$editor$getModel;
      var line = (_this$editor$getModel = this.editor.getModel()) === null || _this$editor$getModel === void 0 ? void 0 : _this$editor$getModel.getLineCount();
      assertNotNull(line);
      this.editor.revealLine(line, 1);
    }
    this.stopFlushTimer();
    this.bufferedMessages = [];
  }
  truncateLogIfNecessary() {
    if (this.messages.length > LogView.maxLogSize) {
      this.messages = this.messages.splice(this.messages.length - LogView.truncateSize);
    }
  }
  scrollToBottom() {
    var _this$editor5, _this$editor5$getMode;
    if (!this.editor) {
      return;
    }
    var line = (_this$editor5 = this.editor) === null || _this$editor5 === void 0 || (_this$editor5$getMode = _this$editor5.getModel) === null || _this$editor5$getMode === void 0 || (_this$editor5$getMode = _this$editor5$getMode.call(_this$editor5)) === null || _this$editor5$getMode === void 0 ? void 0 : _this$editor5$getMode.getLineCount();
    assertNotNull(line);
    this.editor.revealLine(line, 1);
  }
  isBottomVisible() {
    if (!this.editor) {
      return true;
    }
    var model = this.editor.getModel();
    var line = model === null || model === void 0 ? void 0 : model.getLineCount();
    assertNotNull(line);
    return this.isLineVisible(line);
  }
  isLineVisible(line) {
    var _this$editor6;
    var visibleRanges = (_this$editor6 = this.editor) === null || _this$editor6 === void 0 ? void 0 : _this$editor6.getVisibleRanges();
    if (visibleRanges == null || visibleRanges.length === 0) {
      return false;
    }
    for (var i = 0; i < visibleRanges.length; i += 1) {
      var range = visibleRanges[i];
      if (range.startLineNumber <= line && line <= range.endLineNumber) {
        return true;
      }
    }
    return false;
  }

  /** Checks if the given log message is visible with the current filters */
  isLogItemVisible(message) {
    var shownLogLevels = this.state.shownLogLevels;
    return shownLogLevels[message.logLevel];
  }
  flush() {
    var text = '';
    for (var i = 0; i < this.bufferedMessages.length; i += 1) {
      var message = this.bufferedMessages[i];
      var logText = LogView.getLogText(message);
      text += logText;
      if (logText.charAt(logText.length - 1) !== '\n') {
        text += '\n';
      }
    }
    this.bufferedMessages = [];
    this.appendLogText(text);
  }
  queue(message) {
    this.bufferedMessages.push(message);
    if (this.bufferedMessages.length === 1) {
      this.flushTimer = setTimeout(this.handleFlushTimeout, LogView.bufferTimeout);
    }
  }
  stopFlushTimer() {
    if (this.flushTimer) {
      clearTimeout(this.flushTimer);
      this.flushTimer = undefined;
    }
  }
  updateDimensions() {
    if (this.editor) {
      this.editor.layout();
    }
  }
  handleClearClick() {
    this.clearLogs();
  }
  clearLogs() {
    this.messages = [];
    this.refreshLogText();
  }
  handleFlushTimeout() {
    this.stopFlushTimer();
    this.flush();
  }
  handleLogMessage(message) {
    this.messages.push(message);
    if (this.editor && this.isLogItemVisible(message)) {
      this.queue(message);
    }
  }
  handleMenuItemClick(logLevel) {
    this.toggleLogLevel(logLevel);
  }
  handleResetClick() {
    this.resetLogLevels();
  }
  handleResize() {
    this.updateDimensions();
  }
  handleToggleAllClick() {
    this.toggleAll();
  }
  render() {
    var popperOptions = {
      placement: 'bottom-end'
    };
    var shownLogLevels = this.state.shownLogLevels;
    var actions = this.getMenuActions(shownLogLevels);
    return /*#__PURE__*/_jsxs("div", {
      className: "log-pane h-100 w-100",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "log-pane-menu",
        children: [/*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: "btn-clear-logs",
          onClick: this.handleClearClick,
          icon: dhTrashUndo,
          tooltip: "Clear log"
        }), /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: "btn-link-icon btn-overflow",
          icon: vsGear,
          tooltip: "Log Settings",
          onClick: () => {
            // no-op: click is handled in `DropdownMenu'
          },
          children: /*#__PURE__*/_jsx(DropdownMenu, {
            actions: actions,
            popperClassName: "log-level-menu-popper",
            popperOptions: popperOptions
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "log-pane-editor h-100 w-100",
        ref: editorContainer => {
          this.editorContainer = editorContainer;
        }
      })]
    });
  }
}
_defineProperty(LogView, "DefaultLogLevels", [LogLevel.STDOUT, LogLevel.ERROR, LogLevel.FATAL, LogLevel.STDERR, LogLevel.WARN]);
_defineProperty(LogView, "AllLogLevels", [LogLevel.INFO, LogLevel.STDOUT, LogLevel.ERROR, LogLevel.FATAL, LogLevel.STDERR, LogLevel.WARN, LogLevel.DEBUG, LogLevel.TRACE]);
/** ms to buffer log messages before processing them */
_defineProperty(LogView, "bufferTimeout", 16);
/** Maximum number of messages to store in the log */
_defineProperty(LogView, "maxLogSize", 131072);
_defineProperty(LogView, "truncateSize", 65536);
export default LogView;
//# sourceMappingURL=LogView.js.map